// import { Avatar, Image, Progress, Typography, Menu, Dropdown, Tooltip } from 'antd'
// import React, { useState } from 'react'
// import { ClockCircleFilled, InfoCircleOutlined, LinkOutlined, UserOutlined } from '@ant-design/icons'
// import { MdCastConnected, MdMoreVert } from 'react-icons/md'
// import { Api, Color } from 'services'
// import moment from 'moment'
// import EditFormModal from './modals/editForm'
// import EditOccurrance from './modals/editOccurrance'
// import DelConfirmModal from './modals/deleteConfirmModal'
// import { connect } from 'react-redux'
// import { SquareSubIcon } from 'components/subIcon'
// import { IoMdChatbubbles, IoMdVideocam } from 'react-icons/io'
// import { RiWirelessChargingLine } from 'react-icons/ri'
// import { FaGraduationCap } from 'react-icons/fa'
// import Conference  from "Assets/schedule/confrence.svg"
// import Broadcast  from "Assets/schedule/Broadcast.svg"
// import Offline from "Assets/schedule/ofline.svg"
// import { EventRegister } from 'react-native-event-listeners'
// import { EmbedModal, regexMeet } from './onGoingClassCard'
// import { postEmbedLink } from 'actions/broadcast'
// import OtherColor from "Assets/schedule/other_color.svg"
// import { useHistory } from 'react-router-dom'
// import { setLiveStreamUrl } from 'actions/schedule'
// import UserAvatar from 'components/userAvatar'


// const { Text } = Typography
// const ScheduleClassCard = ({
//   scheduleItem, index, togglePageLoader, scheduleId, access, delOrCancel, postEmbedLink, setLiveStreamUrl
// }) => {
//   const history = useHistory();
//   const [isVisibleEditSchedule, setVisibleEditSchedule] = useState(false)
//   const [isVisibleEditOccurance, setVisibleEditOccurance] = useState(false)
//   const [isDeleteModal, toogleDeleteModal] = useState(false)
//   const [embedModalVisible, setEmbedModalVisible] = useState(false);
//   const [embedding, setEmbedding] = useState(false);
//   const menu = (
//     <Menu style={{ width: "150px", background: "#FFFFFF", boxShadow: "8px 8px 18px #302A5F14", borderRadius: "8px" }}>
//       <Menu.Item key="1" onClick={() => setVisibleEditOccurance(true)}>
//         Edit occurrence
//       </Menu.Item>
//       <Menu.Item key='2' onClick={() => setVisibleEditSchedule(true)}>
//         Edit schedule
//       </Menu.Item>
//       {
//         scheduleItem.mode === 'Others' ?
//         <>
//         <Menu.Item key="3" onClick={()=>{handleJoin()}}>
//           {scheduleItem.sUrl!=undefined?'Replace link':'Add link'}      
//         </Menu.Item>
//         {scheduleItem?.sUrl != undefined ?
//         <Menu.Item key="4" onClick={()=>{playStream()}}>
//             Play stream
//         </Menu.Item>
//         :null}
//         </>
//         :null
//       }
//     </Menu>

//   );
//   const playStream = () => {
//     if (scheduleItem.sUrl.match(regexMeet)){
//       window.open(scheduleItem.sUrl, '_blank');
//     }else{
//       setLiveStreamUrl(scheduleItem?.sUrl)
//       history.push('/liveplayer')
//     }
//   }

//   const handleJoin = () => {
//     setEmbedModalVisible(true);
//   }

//   const onEmbed = async(link) => {
//     setEmbedding(true);
//     await postEmbedLink({id:scheduleItem.id, sUrl: link})
//     setEmbedding(false);
//     setEmbedModalVisible(false);
//     EventRegister.emit('apicall:scheduleHome');
//   }

//   return (
//     <div className="scheduleclass-main">
//       <div style={{ display: 'flex', flexDirection: 'row' }}>
//         <div className="scheduleclass-img-text">
//           <div>
//             <SquareSubIcon icon={scheduleItem?.subject?.icon ? scheduleItem?.subject?.icon : ''} name={scheduleItem?.subject?.name ? scheduleItem?.subject?.name : ''} size={40} />
//           </div>
//           <div style={{ width: "200px", marginLeft: '10px', display: 'flex', flexDirection: 'column' }}>
//             {scheduleItem.mode == "Broadcast" ?
//               <div style={{ width: 'fit-content', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFF4D5', borderRadius: '8px', padding: '3px 7px' }}>
//                 <img src={Broadcast} style={{ color: '#FFA931', textAlign: 'center', height: "16px", width: "16px" }} />
//                 <Text style={{ fontSize: '10px', color: '#FFA931', marginLeft: '5px' }}>Broadcast</Text>
//               </div>
//               :
//               scheduleItem.mode == "Conference" ?
//                 <div style={{ width: 'fit-content', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#F6F4FE', borderRadius: '8px', padding: '3px 7px' }}>
//                   <img src={Conference} style={{ color: '#594099', height: "16px", width: "16px" }} />
//                   <Text style={{ color: '#594099', marginLeft: '5px', fontSize: '10px' }}>Conference</Text>
//                 </div>
//                 :
//                 scheduleItem.mode == 'Others' ?
//                 <div style={{ width: 'fit-content', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFE5F4', borderRadius: '8px', padding: '3px 7px' }}>
//                     <img src={OtherColor} style={{ color: '#E50087',height:"16px",width:"16px" }} />
//                     <Text style={{ color: '#E50087', marginLeft: '5px', fontSize: '10px' }}>Other</Text>
//                 </div>
//                 :
//                 <div style={{ width: 'fit-content', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#E9FCF5', borderRadius: '8px', padding: '3px 7px' }}>
//                   <img src={Offline} style={{ color: '#28DF99', textAlign: 'center', height: "16px", width: "16px" }} />
//                   <Text style={{ fontSize: '10px', color: '#28DF99', marginLeft: '5px' }}>Offline</Text>
//                 </div>
//             }
//             <Tooltip title={scheduleItem?.subject?.name ? scheduleItem?.subject?.name : null}>
//               <Text style={{ fontWeight: 'bold', fontSize: '15px', fontFamily: 'roboto', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{scheduleItem?.subject?.name}</Text>
//             </Tooltip>
//             <div style={{ width: '100%',  display:"flex", flexDirection:"row",alignItems:"center",  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
//               <Tooltip title={scheduleItem?.standards.length != 0 ? scheduleItem?.standards?.map((item, index, array) => (`${item?.std + "-" + item?.section}${index === array.length - 1 ? '' : ' | '}`)) : null}>
//                 <FaGraduationCap style={{ color: 'purple', marginRight: '5px' }} />
//               </Tooltip>
//               {scheduleItem?.standards.length != 0 ? scheduleItem?.standards?.map((item, index, array) => (
//                 <Text style={{ fontSize: '80%', fontFamily: 'roboto' }} key={index}>{item?.std}-{item?.section}{index === array.length - 1 ? '' : '|'}</Text>
//               )) : null}
//             </div>

//           </div>
//         </div>
//         {access == true ?
//           <div style={{ width: '18px' }}>
//             <Dropdown overlay={menu} disabled={false} placement="bottomRight" >
//               <MdMoreVert style={{ width: "24px", height: "24px", color: "#AEAEAE" }} />
//             </Dropdown>
//           </div> : null}
//         {(isVisibleEditSchedule && <EditFormModal isModalVisible={isVisibleEditSchedule} setModalVisible={setVisibleEditSchedule} editData={scheduleItem} toogleDeleteModal={toogleDeleteModal} togglePageLoader={togglePageLoader} />)}
//         {(isVisibleEditOccurance && <EditOccurrance isModalVisible={isVisibleEditOccurance} setModalVisible={setVisibleEditOccurance} editData={scheduleItem} togglePageLoader={togglePageLoader} toogleDeleteModal={toogleDeleteModal} />)}
//         {(isDeleteModal && <DelConfirmModal isModalVisible={isDeleteModal} setModalVisible={toogleDeleteModal} id={scheduleId} delOrCancel={delOrCancel} />)}
//       </div>
//       <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start' }}>
//         <div style={{display:"flex", flexDirection:"row", alignItems:"center",  width: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
//           <UserAvatar size="small" shape="circle" name={scheduleItem?.teacher?.name} img={scheduleItem?.teacher?.image == "default.png" ? "" : `${Api._s3_url}${scheduleItem?.teacher?.image}`} />
//           <Text style={{ marginLeft: '5px', color: '#636363', fontSize: '10px', fontFamily: 'roboto' }}>{scheduleItem?.teacher?.name}</Text>
//         </div>
//         <div >
//           <ClockCircleFilled style={{ fontSize: '11px', color: '#594099' }} />
//           <Text style={{ marginLeft: '5px', color: '#636363', fontSize: '10px', fontFamily: 'roboto' }}>{`${moment(scheduleItem?.startTime, 'HH:mm:ss').format("hh:mm A")}-${moment(scheduleItem?.endTime, 'HH:mm:ss').format("hh:mm A")}`}</Text>
//         </div>
//       </div>
//       {embedModalVisible ? <EmbedModal adding={scheduleItem.sUrl==undefined} embedding={embedding} visible={embedModalVisible} onClose={()=>{setEmbedModalVisible(false)}} onOk={onEmbed}/>:null}
//     </div>
//   )
// }



// const mapStateToProps = (state) => {
//   const {
//     scheduleId,
//     access,
//     delOrCancel
//   } = state.schedule;
//   return {
//     scheduleId,
//     access,
//     delOrCancel
//   };
// };

// const mapDispatchToProps = (dispatch) => ({
//   postEmbedLink: (params, c, sc) => dispatch(postEmbedLink(params, c, sc)),
//   setLiveStreamUrl: (url) => dispatch(setLiveStreamUrl(url))
// });

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps

// )(ScheduleClassCard);

import { Typography, Dropdown, Menu, Tooltip } from "antd";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { MdMoreVert } from "react-icons/md";
import { IoMdVideocam } from "react-icons/io";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import { SquareSubIcon } from "components/subIcon";

import Conference from "Assets/schedule/confrence.svg";
import Online from "Assets/schedule/online.svg";
import Offline from "Assets/schedule/offline.svg";
import OtherColor from "Assets/schedule/other_color.svg";

import EditFormModal from "./modals/editForm";
import EditOccurrance from "./modals/editOccurrance";
import DelConfirmModal from "./modals/deleteConfirmModal";
import { EmbedModal, regexMeet } from "./onGoingClassCard";
import { postEmbedLink } from "actions/broadcast";
import { setLiveStreamUrl } from "actions/schedule";
import { EventRegister } from "react-native-event-listeners";
import ScheduleDetailsDrawer from "./ScheduleDetailsDrawer";
import { getSchedulePermissions, canManageClassLink } from "./schedulePermissions";

const { Text } = Typography;

const teacherIcon = require("../../Assets/schedule/teacher.svg").default;
const timerIcon = require("../../Assets/schedule/timer.svg").default;

const ScheduleClassCard = ({
  scheduleItem,
  access,
  scheduleId,
  delOrCancel,
  postEmbedLink,
  setLiveStreamUrl,
  user,
  togglePageLoader,
  pageLoader,
  drawerValue,
  drawerBooleanState
}) => {
  const history = useHistory();

  const [editSchedule, setEditSchedule] = useState(false);
  const [editOccurance, setEditOccurance] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [embedModalVisible, setEmbedModalVisible] = useState(false);
  const [embedding, setEmbedding] = useState(false);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    // When embed modal (Add/Replace link) closes, the menu state is reset
    if (!embedModalVisible) {
      setMenuOpen(false);
    }
  }, [embedModalVisible]);

  useEffect(() => {
    if (
      history.location.state?.scheduleId &&
      (history.location.state?.scheduleId === scheduleItem?.id || history.location.state?.scheduleId === scheduleItem?.scheduleId || history.location.state?.scheduleId === scheduleItem?.occurrenceId) &&
      (history.location.state?.activeTab === 'quizzes' || history.location.state?.activeTab === 'resources')
    ) {
      setDetailsOpen(true);
    }
  }, [history.location.state, scheduleItem.id]);

  // Role/privilege questions all go through the matrix now (schedulePermissions.js);
  // the local normalizeList / userPrivileges / hasPrivilege trio this card used to keep
  // was a second, subtly different copy of the same logic.
  const permissions = getSchedulePermissions(user);

  // Gates the Others-mode "..." menu, whose Add/Replace link writes the livestream URL
  // onto the occurrence. That one action is not the matrix's "Creation" column: the
  // class's own teacher can supply the link at any privilege level, since on an Others
  // class it is their own meeting. Everyone else still needs Creation rights.
  const canPerformAction = canManageClassLink(user, scheduleItem);

  // Opening the drawer is not the same as being able to act inside it. Every row of the
  // matrix that can see the Schedule module has at least one tab waiting behind this
  // card - Attendance for Operation + AttendanceMarker, Resources/Quizzes for a plain
  // Data Operator - and clicking the card is the only way to reach any of them. So the
  // gate is simply "can this user see the module at all"; which tabs actually appear,
  // and whether they are editable, is decided inside ScheduleDetailsDrawer from the same
  // matrix. This used to be `canPerformAction || isAssignedTeacher`, which locked out
  // every AttendanceMarker and every Data Operator.
  const canOpenDetails = permissions.canViewModule;


  const duration = moment.duration(
    moment(scheduleItem?.endTime, "HH:mm:ss").diff(
      moment(scheduleItem?.startTime, "HH:mm:ss")
    )
  );

  const playStream = () => {
    if (scheduleItem?.sUrl?.match(regexMeet)) {
      window.open(scheduleItem.sUrl, "_blank");
    } else {
      setLiveStreamUrl(scheduleItem?.sUrl);
      history.push("/liveplayer");
    }
  };

  const onEmbed = async (link) => {
    setEmbedding(true);
    if (togglePageLoader) togglePageLoader(true)
    await postEmbedLink({ id: scheduleItem.id, sUrl: link });
    if (togglePageLoader) togglePageLoader(false)
    setEmbedding(false);
    setEmbedModalVisible(false);
    EventRegister.emit("apicall:scheduleHome");
  };

  // const menu = (
  //   <Menu
  //     style={{
  //       width: 200,
  //       background: "#FFFFFF",
  //       boxShadow: "8px 8px 18px #302A5F14",
  //       borderRadius: 8,
  //     }}
  //   >
  //     <Menu.Item onClick={({ domEvent }) => { domEvent && domEvent.stopPropagation(); setEditOccurance(true); }}>
  //       Edit occurrence
  //     </Menu.Item>
  //     <Menu.Item onClick={({ domEvent }) => { domEvent && domEvent.stopPropagation(); setEditSchedule(true); }}>
  //       Edit schedule
  //     </Menu.Item>
  //   </Menu>
  // );

  return (
    <div
      className={canOpenDetails ? 'scheduleclass-main scheduleclass-main--scheduled clickable' : 'scheduleclass-main scheduleclass-main--scheduled'}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={(e) => {
        // Every modal below (Add link, edit, delete) and the drawer itself are
        // rendered inside this div, and React bubbles events out of a portal
        // along the React tree rather than the DOM one - so the click that
        // dismisses a modal by its mask arrives here too and would open the
        // details drawer the moment the modal closed. Checking what was really
        // clicked is the reliable test: e.target on a synthetic event reports
        // the true originating node even when it lives in a portal outside this
        // card's DOM subtree. Same guard as onGoingClassCard's.
        if (e.target.closest && e.target.closest('.ant-dropdown, .ant-modal, .ant-modal-wrap, .ant-modal-mask, .ant-drawer')) {
          return;
        }
        // Not allowed to open the drawer at all (a restricted Operator/Data Operator,
        // or a Teacher looking at someone else's class) - swallow the click.
        if (!canOpenDetails) {
          e.stopPropagation();
          return;
        }

        setDetailsOpen(true);
        if (typeof drawerBooleanState === 'function') {
          drawerBooleanState('');
        }
      }}
      style={{
        position: "relative",
        cursor: canOpenDetails ? 'pointer' : 'default',
        width: '100%',
        maxWidth: 330,
        background: "transparent",
      }}


    >
      {/* TOP BAR */}
      <div
        style={{
          // Was position:absolute with hand-picked left/right values that had to
          // coincidentally match the card's own padding for this row to line up
          // with the subject icon below it - never quite exact. A normal in-flow
          // row shares that same padding automatically, guaranteeing the two
          // rows start at the same left edge instead of approximating it.
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Text style={{ fontSize: 12, color: "#636363" }}>
          {moment(scheduleItem?.startTime, "HH:mm:ss").format("hh:mm A")} -{" "}
          {moment(scheduleItem?.endTime, "HH:mm:ss").format("hh:mm A")}
        </Text>

        <div style={{ display: "flex", alignItems: "center" }}>
          {/* MODE PILL */}
          {scheduleItem.mode === "Zoom 40" ? (
            <div style={{ display: "flex", alignItems: "center", background: "#E7F3FF", borderRadius: 16, padding: "4px 10px" }}>
              <IoMdVideocam style={{ color: "#1089FF" }} />
              <Text style={{ fontSize: 10, color: "#1089FF", marginLeft: 5 }}>Zoom 40</Text>
            </div>
          ) : scheduleItem.mode === "Broadcast" ? (
            <div style={{ display: "flex", alignItems: "center", background: "#E9FFF9", border: "1px solid #C8EEE4", borderRadius: 16, padding: "4px 10px" }}>
              <img src={Online} style={{ width: 14 }} />
              <Text style={{ fontSize: 10, color: "#00A566", marginLeft: 5 }}>Online</Text>
            </div>
          ) : scheduleItem.mode === "Conference" ? (
            <div style={{ display: "flex", alignItems: "center", background: "#F6F4FE", borderRadius: 16, padding: "4px 10px" }}>
              <img src={Conference} style={{ width: 14 }} />
              <Text style={{ fontSize: 10, color: "#594099", marginLeft: 5 }}>Conference</Text>
            </div>
          ) : (scheduleItem.mode === "Others" || scheduleItem.mode === "Other") ? (
            <div style={{ display: 'inline-flex', alignItems: 'center', position: 'relative' }}>
              {(!(canPerformAction && (hovered || menuOpen))) && (
                <div style={{ display: "flex", alignItems: "center", background: "#FFE5F4", borderRadius: 16, padding: "4px 10px" }}>
                  <img src={OtherColor} style={{ width: 14 }} />
                  <Text style={{ fontSize: 10, color: "#E50087", marginLeft: 5 }}>Others</Text>
                </div>
              )}
              {/* Only allow privileged users to see the menu */}
              {(canPerformAction) && (
                <div style={{
                  position: (hovered || menuOpen) ? 'relative' : 'absolute',
                  right: 0,
                  opacity: hovered || menuOpen ? 1 : 0,
                  transition: 'opacity 0.12s',
                  pointerEvents: hovered || menuOpen ? 'auto' : 'none'
                }}>
                  <Dropdown overlay={
                    <Menu style={{ borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                      <Menu.Item key="1" onClick={({ domEvent }) => { domEvent && domEvent.stopPropagation(); setEmbedModalVisible(true); }}>{scheduleItem.sUrl ? 'Replace link' : 'Add link'}</Menu.Item>
                      {scheduleItem?.sUrl ? <Menu.Item key="2" onClick={({ domEvent }) => { domEvent && domEvent.stopPropagation(); playStream(); }}>Play stream</Menu.Item> : null}
                    </Menu>
                  } trigger={['hover']} placement="bottomRight" onVisibleChange={(v) => { setMenuOpen(v); }}>
                    <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '4px' }}>
                      <MdMoreVert onClick={(e) => e.stopPropagation()} style={{ fontSize: 18, color: "#AEAEAE" }} />
                    </div>
                  </Dropdown>
                </div>
              )}
            </div>
          ) : (
            <div style={{ display: "flex", alignItems: "center", background: "#FFD8DA", border: "1px solid #FFF5F6", borderRadius: 16, padding: "4px 10px" }}>
              <img src={Offline} style={{ width: 14 }} />
              <Text style={{ fontSize: 10, color: "#FF414D", marginLeft: 5 }}>Offline</Text>
            </div>
          )}


          {/* {access && (
            <Dropdown overlay={menu} placement="bottomRight">
              <MdMoreVert
                onClick={(e) => e.stopPropagation()}
                style={{ fontSize: 22, color: "#AEAEAE", cursor: "pointer" }}
              />
            </Dropdown>
          )} */}
        </div>
      </div>

      {/* MAIN CONTENT */}
      {/* paddingTop: 32 used to reserve room for the position:absolute TOP BAR -
          it's a normal in-flow row now, so it already takes its own space; this
          just needs a visual gap between the two rows. */}
      <div style={{ paddingTop: 12 }}>
        <div style={{ display: "flex", gap: 16 }}>
          <SquareSubIcon
            icon={scheduleItem?.subject?.icon || ""}
            name={scheduleItem?.subject?.name || ""}
            size={44}
          />

          <div style={{ flex: 1, minWidth: 0 }}>
            <Text 
              style={{ fontSize: 16, fontWeight: 600, display: 'block' }}
              ellipsis={{ tooltip: scheduleItem?.subject?.name }}
            >
              {scheduleItem?.subject?.name}
            </Text>

            <div style={{ display: "flex", gap: 16, fontSize: 13, color: "#636363" }}>
              <div style={{ display: "flex", gap: 6, alignItems: "center", minWidth: 0 }}>
                <img src={teacherIcon} width={14} />
                <Text
                  ellipsis={{ tooltip: scheduleItem?.teacher?.name }}
                  style={{ fontSize: 13, color: "#636363", maxWidth: 120 }}
                >
                  {scheduleItem?.teacher?.name}
                </Text>
              </div>
              <div style={{ display: "flex", gap: 6 }}>
                <img src={timerIcon} width={14} />
                {Math.round(duration.asMinutes())} mins
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ marginTop: 16, maxWidth: '100%', overflow: 'hidden' }}>
        {scheduleItem?.standards && scheduleItem.standards.length > 0 ? (
          <Tooltip
            title={scheduleItem.standards.map(item => `${item.std}-${item.section}`).join(', ')}
            placement="bottom"
            getPopupContainer={(trigger) => trigger.parentElement}
          >
            <Text style={{ fontSize: 12, color: "#636363", display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>
              {scheduleItem.standards.map(item => `${item.std}-${item.section}`).join(', ')}
            </Text>
          </Tooltip>
        ) : (
          <Tooltip
            title={scheduleItem?.batchName || ""}
            placement="bottom"
            getPopupContainer={(trigger) => trigger.parentElement}
          >
            <Text style={{ fontSize: 12, color: "#636363", display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>
              {scheduleItem?.batchName || ""}
            </Text>
          </Tooltip>
        )}
      </div>

      {/* MODALS */}
      {editSchedule && <EditFormModal isModalVisible setModalVisible={setEditSchedule} editData={scheduleItem} />}
      {editOccurance && <EditOccurrance isModalVisible setModalVisible={setEditOccurance} editData={scheduleItem} />}
      {deleteModal && <DelConfirmModal isModalVisible setModalVisible={setDeleteModal} scheduleId={scheduleItem?.occurrenceId || scheduleItem?.occuranceId || scheduleItem?.occurrence_id || scheduleItem?.id} delOrCancel={delOrCancel} />}
      {embedModalVisible && (
        <EmbedModal
          adding={!scheduleItem.sUrl}
          embedding={embedding}
          visible={embedModalVisible}
          onClose={() => setEmbedModalVisible(false)}
          onOk={onEmbed}
        />
      )}

      {/* DRAWER */}
      <ScheduleDetailsDrawer
        open={detailsOpen}
        onClose={() => setDetailsOpen(false)}
        schedule={scheduleItem}
        togglePageLoader={togglePageLoader}
        pageLoader={pageLoader}
        isScheduledClass={true}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  scheduleId: state.schedule.scheduleId,
  access: state.schedule.access,
  delOrCancel: state.schedule.delOrCancel,
  user: state.session.user,
  drawerValue: state.schedule.drawerValue,
});

const mapDispatchToProps = (dispatch) => ({
  postEmbedLink: (params) => dispatch(postEmbedLink(params)),
  setLiveStreamUrl: (url) => dispatch(setLiveStreamUrl(url)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleClassCard);
